var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContract(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.402,
    height: 9.377,
    viewBox: "0 0 16.402 9.377",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-back",
    "data-name": "Icon ionic-ios-arrow-back",
    d: "M10.64,12.5l6.206-6.2a1.172,1.172,0,0,0-1.66-1.655L8.154,11.67a1.17,1.17,0,0,0-.034,1.616l7.061,7.075a1.172,1.172,0,0,0,1.66-1.655Z",
    transform: "translate(20.703 -7.813) rotate(90)",
    fill: "#a5b5af"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.da41cfe67ca9cbf50257f771cb0ed133.svg";
export { ForwardRef as ReactComponent };